import base from "@/store/utils/api-route/base";

const snapConsoleAPI = {
    list: `${base.meta}list_snap_console`,
    updatePin: `${base.snapConsole}update_pin_console`
}

export default snapConsoleAPI